import React from "react";
import {
  ArrowRight,
  Award,
  CheckCircle2,
  HeartHandshake,
  PackageCheck,
  ShieldCheck,
  Sparkles,
  Truck,
  Users,
} from "lucide-react";
import { Link } from "react-router-dom";
import storeLogo from "../../assets/images/logo.png";

export default function AboutUs() {
  return (
    <main className="page-shell content-page about-page">
      <div className="breadcrumbs">
        <Link to="/">Home</Link>
        <span>/</span>
        <span>About Us</span>
      </div>

      <section className="about-hero">
        <div className="about-hero__copy">
          <span className="eyebrow">
            <Sparkles size={14} /> THE SUGAM STORE STORY
          </span>
          <h1>
            Thoughtful essentials,
            <br />
            crafted for <em>everyday living.</em>
          </h1>
          <p>
            Welcome to Sugam Store. We believe finding high-quality, dependable, and 
            practical products should be effortless, reliable, and delightful. Sourced with 
            integrity, delivered with care right to your doorstep.
          </p>
          <div className="about-hero__actions">
            <Link to="/shop" className="button button--primary">
              Explore Our Catalog <ArrowRight size={17} />
            </Link>
            <Link to="/contact" className="button button--quiet">
              Contact Our Team
            </Link>
          </div>
        </div>
        <div className="about-hero__visual">
          <div className="about-visual-card">
            <img src={storeLogo} alt="Sugam Store" />
            <div className="about-visual-badge">
              <Award size={20} />
              <div>
                <strong>Quality Guaranteed</strong>
                <small>100% Verified Products</small>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-stats-grid">
        <div className="stat-card">
          <strong>50K+</strong>
          <span>Happy Customers</span>
          <p>Serving households across India with verified essentials.</p>
        </div>
        <div className="stat-card">
          <strong>20,000+</strong>
          <span>Pin Codes Served</span>
          <p>Fast express logistics reaching every corner of India.</p>
        </div>
        <div className="stat-card">
          <strong>99.4%</strong>
          <span>On-Time Delivery</span>
          <p>Orders dispatched within 24-48 hours with live tracking.</p>
        </div>
        <div className="stat-card">
          <strong>4.9/5</strong>
          <span>Customer Rating</span>
          <p>Backed by real reviews and verified customer satisfaction.</p>
        </div>
      </section>

      <section className="about-mission-section">
        <div className="section-heading">
          <div>
            <p className="eyebrow">OUR CORE PRINCIPLES</p>
            <h2>What Makes Sugam Store Different</h2>
          </div>
        </div>
        <div className="about-features-grid">
          <div className="about-feature-card">
            <div className="feature-icon">
              <PackageCheck size={24} />
            </div>
            <h3>Handpicked & Inspected</h3>
            <p>
              We don't list thousands of random items. Every product in our catalog undergoes rigorous 
              checks for build quality, durability, and practical everyday value before reaching you.
            </p>
          </div>
          <div className="about-feature-card">
            <div className="feature-icon">
              <ShieldCheck size={24} />
            </div>
            <h3>100% Authenticity Guarantee</h3>
            <p>
              We source directly from authorized manufacturers and verified brand distributors. 
              Zero counterfeits, zero compromises — you receive genuine merchandise every single time.
            </p>
          </div>
          <div className="about-feature-card">
            <div className="feature-icon">
              <Truck size={24} />
            </div>
            <h3>Lightning Fast Dispatch</h3>
            <p>
              Your time is valuable. Most orders are packed safely with multi-layer protective packaging 
              and dispatched within 24 hours via India's top courier networks.
            </p>
          </div>
          <div className="about-feature-card">
            <div className="feature-icon">
              <HeartHandshake size={24} />
            </div>
            <h3>Customer-First Support</h3>
            <p>
              Have a question or need assistance with your order? Our support team is always ready 
              to assist via email, phone, and WhatsApp without complicated automated loops.
            </p>
          </div>
        </div>
      </section>

      <section className="about-cta-banner">
        <div>
          <span className="eyebrow">JOIN OUR COMMUNITY</span>
          <h2>Ready to upgrade your everyday routine?</h2>
          <p>Discover everyday essentials, seasonal favorites, and exclusive member discounts.</p>
        </div>
        <Link to="/shop" className="button button--primary">
          Start Shopping <ArrowRight size={17} />
        </Link>
      </section>
    </main>
  );
}
